/*
 * Copyright (c) 2022-2024. Haodong JU
 */

import i18n from '../../../i18n'
import hillo from 'hillo'
import { isEmpty, isNumber } from 'lodash'
import { Remember } from '@/model/global/GlobalSettings'
import { ifReserveOpen } from '@/model/dataLayer/service/reservation/reservation'

const config = require('@/assets/config.json')

export function isBlank (val) {
  return isEmpty(val) && !isNumber(val)
}

export const getIndexData = function () {
  return hillo.get('IndexData.php', {
    lang: Remember.lang
  }, {
    timeout: 90 * 1000
  })
}

export const rejectTakeAwayOrder = function (reason, tableId) {
  return hillo.post('Complex.php', {
    op: 'rejectTakeAwayOrder',
    reason,
    tableId
  })
}

export const printSummaryBon = function (filter) {
  return hillo.post('Complex.php?op=printSummary', { ...filter })
}
export const sendSummaryBon = function (filter) {
  return hillo.post('Complex.php?op=sendSummary', { ...filter }, {
    timeout: 300 * 1000
  })
}

// 新ZBon
export const newPrintZBon = async function (item, sendToMail, blockPrint) {
  return (await hillo.post('ZBon.php?op=printCombined', {
    zbonNumber: item,
    sendToMail,
    blockPrint
  }))
}

// 新新ZBon接口
export async function newNewPrintZbon (ZbonList) {
  const res = ZbonList.toString()
  return (await hillo.post('ZBon.php?op=sendZbonCombinedByZbonNumbersInOneZip', {
    zbonNumbers: res
  }, { timeout: ZbonList.length * 8 * 1000, timeoutErrorMessage: 'Time Out,Please Try Again Or Call Us' }))
}

export const newSetZBon = async function (item, sendToMail) {
  return (await hillo.post('ZBon.php?op=generateAndPrintCombined', {
    ...item,
    sendToMail
  }))
}

export const newGetZBon = async function (timeSpan) {
  const [timeStart, timeEnd] = timeSpan
  return (await hillo.get('ZBon.php?op=searchZbonCombinedRecord', {
    fromDateTime: timeStart,
    toDateTime: timeEnd
  })).content
}

// 长跨度ZBON信息查询

export async function getLongDateRangeZBonInfo (timeSpan) {
  const [timeStart, timeEnd] = timeSpan
  return (await hillo.get('Zbon.php?op=getZbonListeral', {
    fromDateTime: timeStart,
    toDateTime: timeEnd
  })).content
}

// 销售统计
export const printSalesBon = async function (timeSpan) {
  const [timeStart, timeEnd] = timeSpan
  return (await hillo.post('Dishes.php?op=printSalesBon', {
    start: timeStart,
    end: timeEnd,
    categoryIds: '',
    hideAttributeIds: ''
  }))
}

export const sendSalesBon = async function (timeSpan) {
  const [timeStart, timeEnd] = timeSpan
  return (await hillo.post('Dishes.php?op=sendSalesBonEmail', {
    start: timeStart,
    end: timeEnd,
    categoryIds: '',
    hideAttributeIds: ''
  }))
}

export async function sendManySalesBonEmail (timeArr) {
  const params = []
  for (const timeSpan of timeArr) {
    const [timeStart, timeEnd] = timeSpan
    params.push({
      start: timeStart,
      end: timeEnd,
      dishCategoryTypeIds: '',
      dishCategoryIds: '',
      hideAttributeIds: ''
    })
  }
  return await hillo.post('Dishes.php?op=sendManySalesBonEmail', {
    params: JSON.stringify(params)
  })
}

// 配送列表
export const printDeliveryBon = async function (timeSpan) {
  const [timeStart, timeEnd] = timeSpan
  return await hillo.post('Orders.php?op=printDeliveryBon', {
    fromTime: timeStart,
    toTime: timeEnd
  })
}

// 时间统计
export const printRealTimeSalesBon = function (timeSpan, dishCategoryIds) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [timeStart, timeEnd] = timeSpan
  return hillo.post('BackendData.php?op=printRealTimeSalesBon', {
    timeStart,
    timeEnd,
    dishCategoryIds
  })
}

export const sendRealTimeSalesBon = function (timeSpan, dishCategoryIds) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [timeStart, timeEnd] = timeSpan
  return hillo.post('BackendData.php?op=sendRealTimeSalesBonEmail', {
    timeStart,
    timeEnd,
    dishCategoryIds
  })
}

export const printRealTimeAttributeSalesBon = function () {
  return hillo.post('BackendData.php?op=PrinterRealTimeAttributeSaleBon')
}

export async function previewZBon (startDate, endDate) {
  return (await hillo.get('ZBon.php?op=previewBySpan', {
    startDate,
    endDate
  })).content
}

export async function previewZBonPrintTemplate (startDate, endDate) {
  return (await hillo.get('ZBon.php?op=previewZBonByDaySpanTemplate', {
    startDate,
    endDate
  })).content
}

export const getDetailOrder = function (id) {
  return hillo.get('BackendData.php', {
    // params: {
    op: 'billDetail',
    lang: i18n.locale.toUpperCase(),
    id // },
  })
}
export const checkServant = function (pw, tableId) {
  return hillo.get('Servant.php', {

    op: 'checkServant',
    pw,
    tableId

  })
}
export const removeAllData = function (payMethod, id) {
  return hillo.post('Complex.php', {
    op: 'removeAllData',
    payMethod,
    id
  })
}

export const manageCashAccount = function (amount, note = '', isDatevAccountRef = null) {
  return hillo.post('Complex.php?op=manageCashAccount', {
    datevAccountRef: isDatevAccountRef,
    amount,
    note
  })
}
export const getCurrentCashAmount = async function () {
  return (await hillo.get('Complex.php?op=getCurrentCashAmount')).content?.currentCashAmount ?? 0
}
export const printServantSummaryBon = function (id, start, end) {
  return hillo.get('Servant.php', {
    op: 'printSummaryBon',
    id,
    start,
    end
  })
}

export const Login = function (password) {
  return hillo.get(config.companyRoot, {
    op: 'logIn',
    password
  })
}

export const reprintOrder = function (id, withTitle = 0, printCount = 1) {
  return hillo.post('BackendData.php?op=reprintOrder', {
    id,
    withTitle,
    printCount
  })
}

export const findBestIp = function (id) {
  return hillo.get(config.companyRoot, {
    op: 'findBestIp',
    deviceId: id
  })
}
export const getRestaurantInfo = function () {
  return hillo.get('Restaurant.php?op=view')
}

export async function getNiceRestaurantInfo () {
  return (await hillo.get('Restaurant.php?op=view')).content[0]
}

export const updateRestaurantInfo = function (item) {
  return hillo.post('Restaurant.php?op=update', {
    ...item,
    showloading: true
  })
}
export const sendMsg = function (title, content) {
  return hillo.post('Complex.php?op=sendEmailToUS', {
    title,
    content
  })
}

export async function reservationReady () {
  return (await ifReserveOpen())
}

export const addMultipleTable = function (sectionId, start, end, digit, seatCount) {
  return hillo.post('Tables.php?op=massAddSpan', {
    sectionId,
    start,
    end,
    digit,
    seatCount
  })
}
export const reprintZbon = function (id) {
  return hillo.post('ZBon.php?op=reprintZbon', {
    id
  })
}

export const getOneMemberCardDetail = function (id) {
  return hillo.get('MemberCard.php?', {
    op: 'GetMemberCardDetail',
    id
  })
}

export const printAllQR = function () {
  return hillo.get('QRGen.php?op=printAllQR')
}

export const getRealTimeSaleData = function (timeSpan) {
  if (!timeSpan) {
    return []
  }
  if (!timeSpan.length || timeSpan.length < 2) {
    return []
  }
  const [timeStart, timeEnd] = timeSpan
  return hillo.get('BackendData.php?', {
    op: 'getRealTimeSaleData',
    timeStart,
    timeEnd,
    lang: i18n.locale.toUpperCase()
  })
}

export const getDishesDiscountRuleList = function () {
  return hillo.get('DiscountRule.php?', {
    op: 'getDishesDiscountRuleList'
  })
}

export const removeCategoryImage = function (id) {
  return hillo.post('Category.php?', {
    op: 'removeCategoryImage',
    id
  })
}

export async function showAllDatevSettings () {
  return (await hillo.get('Datev.php?op=showAllDatevSettings')).content
}

export const updateDatevSettings = function (settings) {
  return hillo.post('Datev.php?op=updateDatevSettings', {
    settings: JSON.stringify(settings)
  })
}

export const exportDatevCsv = function () {
  return hillo.get('Datev.php?', {
    op: 'exportDatevCsv'
  })
}

export const exportManyDatevCsv = function (fromDateTime, toDateTime) {
  return hillo.post('Datev.php?op=exportManyDatevCsv', {
    fromDateTime,
    toDateTime
  })
}

export const autoSendDatevCsv = function () {
  return hillo.get('Datev.php?', {
    op: 'autoSendDatevCsv'
  })
}

export const exportCSVFromTo = function (item) {
  return hillo.post('ExportCSV.php?op=timeSelectCsv', { ...item }, {
    responseType: 'blob',
    timeout: 150 * 1000
  })
}

export async function exportNewCSVFromTo (item) {
  return hillo.post('ExportCSV.php?op=downloadV2', { ...item }, {
    timeout: 300 * 1000
  })
}

export async function sendCsvToEmail (startTime, endTime) {
  return await hillo.post('ExportCSV.php?op=timeSelectCsvToEmail', {
    startTime,
    endTime
  }, {
    timeout: 300 * 1000
  })
}

export async function addIngredient (item) {
  return (await hillo.post('/LabelPrint.php?op=addDishIngredient', {
    dishIngredient: JSON.stringify(item)
  }))
}

export async function getIngredientList () {
  return (await hillo.get('/LabelPrint.php?op=getDishIngredientList', {})).content
}

export async function editIngredient (item) {
  return (await hillo.post('/LabelPrint.php?op=updateDishIngredient', {
    id: item.id,
    dishIngredient: JSON.stringify(item)
  }))
}

export async function deleteIngredientList (id) {
  return (await hillo.post('/LabelPrint.php?op=deleteDishIngredient', {
    id
  }))
}

export async function settingToppingIngredient (item) {
  return (await hillo.post('/LabelPrint.php?op=setAttrDishIngredient', {
    attrOperations: JSON.stringify([item])
  }))
}

export async function settingDishIngredient (item) {
  return (await hillo.post('/LabelPrint.php?op=setDishDishIngredient', {
    dishOperations: JSON.stringify([item])
  }))
}

export async function getIngredientByAttr (id) {
  return (await hillo.get('/LabelPrint.php?op=getIngredientsByAttr&attrIds=' + id, {})).content
}

export async function getIngredientByDish (id) {
  return (await hillo.get('/LabelPrint.php?op=getIngredientsByDish&dishIds=' + id, {})).content
}

export async function addSKU (item) {
  return (await hillo.post('/LabelPrint.php?op=addLabelSku', {
    labelSku: JSON.stringify(item)
  }))
}

export async function getSKUList (item) {
  return (await hillo.get('/LabelPrint.php?op=getLabelSkuList', {
    ...item
  })).content
}

export async function editSKU (item) {
  return (await hillo.post('/LabelPrint.php?op=updateLabelSku', {
    labelSku: JSON.stringify(item),
    id: item.id
  }))
}

export async function deleteSKU (id) {
  return (await hillo.post('/LabelPrint.php?op=deleteLabelSku', {
    id
  }))
}

export async function setSKUDish (item) {
  return (await hillo.post('/LabelPrint.php?op=setLabelSkuDish', {
    labelSkuOperations: JSON.stringify([item])
  }))
}

export async function getDishSKUList (id) {
  return (await hillo.post('/LabelPrint.php?op=getLabelSkuList&dishIds=' + id, {})).content
}

export async function getIngredientDishListGroup () {
  return (await hillo.get('/LabelPrint.php?op=getIngredientListGroupByDish', {})).content
}

export async function getIngredientAttrListGroup () {
  return (await hillo.get('/LabelPrint.php?op=getIngredientListGroupByAttr', {})).content
}

export async function editDishNutrition (item, id) {
  return (await hillo.post('/LabelPrint.php?op=setDishNutrition', {
    nutrition: JSON.stringify(item),
    dishId: id
  }))
}

export async function editAttrNutrition (item, id) {
  return (await hillo.post('/LabelPrint.php?op=setAttrNutrition', {
    nutrition: JSON.stringify(item),
    attrId: id
  }))
}

export async function getDishNutrition (id) {
  return (await hillo.post('/LabelPrint.php?op=getDishNutrition&dishIds=' + id, {})).content
}

export async function getAttrNutrition (id) {
  return (await hillo.post('/LabelPrint.php?op=getAttrNutrition&attrIds=' + id, {})).content
}

export async function editAttention (item, id) {
  return (await hillo.post('/LabelPrint.php?op=setDishPreparing', {
    preparing: JSON.stringify(item),
    dishId: id
  })).content
}

export async function getAttention (id) {
  return (await hillo.post('/LabelPrint.php?op=getDishPreparing&dishIds=' + id, {})).content
}

export async function getCashUseful () {
  return (await hillo.get('/Datev.php?op=getAllDatevCashAccount', {})).content
}

export async function deleteUseOfCash (id) {
  return await hillo.post('/Datev.php?op=deleteDatevCashAccount', { id })
}

export async function addUseOfCash (item) {
  return await hillo.post('/Datev.php?op=addDatevCashAccount', { datevCashAccount: JSON.stringify(item) })
}

export async function editUseOfCash (item, id) {
  return await hillo.post('/Datev.php?op=updateDatevCashAccount', {
    datevCashAccount: JSON.stringify(item),
    id
  })
}

export async function setConsumeTypeCategoryRequireCount (item) {
  return await hillo.post('/ConsumeType.php?op=setConsumeTypeCategoryRequireCount', {
    requires: JSON.stringify(item)
  })
}

export async function showConsumeTypeCategoryRequire (id) {
  return (await hillo.get('/ConsumeType.php?op=showConsumeTypeCategoryRequire', {
    consumeTypeId: id
  })).content
}

export async function editAttributeActiveStatus (item) {
  item.langs = JSON.stringify(item.langs)
  return (await hillo.postWithUploadFile('Category.php?op=updateAttributeGroup', item))
}

export async function addDefaultHotPotAGAndA () {
  return await hillo.get('Category.php?op=addDefaultHotPotAGAndA', {})
}

export async function addHotpotBaseDish () {
  return await hillo.get('Dishes.php?op=addHotpotBaseDish', {})
}
